module.exports = __webpack_public_path__ + "static/media/busca_especial.685b8729.svg";